// get_Emplyee_Data
export const GET_EMPLOYEE_API_DATA = 'GET_EMPLOYEE_API_DATA'
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS'
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR'
